import React, { Component } from 'react';
import { Redirect, Link } from "react-router-dom";

class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  render() {
    const {
      onInputChange,
      signUp,
      inputValues,
      redirectToReferrer,
      location,
    } = this.props;
    let { from } = location.state || { from: { pathname: "/advisor" } };
    if (!!redirectToReferrer) return <Redirect to={from} />;
    return (
      <div className="form-wrapper">
        <form
          className="sign-up-form"
          onSubmit={(e) => {
            e.preventDefault();
            signUp(error => this.setState({ error }));
          }}
        >
          {this.state.error && <div style={{ marginBottom: 20, color: 'red' }}>{this.state.error}</div>}
          <label htmlFor="userName">Username</label>
          <input
            type="text"
            id="userName"
            name="userName"
            onChange={e => onInputChange(e.target.name, e.target.value)}
            value={inputValues.userName}
          />
          <label htmlFor="email">Email</label>
          <input
            type="text"
            id="email"
            name="email"
            onChange={e => onInputChange(e.target.name, e.target.value)}
            value={inputValues.email}
          />
          <label htmlFor="email">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            onChange={e => onInputChange(e.target.name, e.target.value)}
            value={inputValues.password}
          />
          <button>
            Sign Up
          </button>
          <div style={{ width: '100%', textAlign: 'center', marginTop: 40 }}>
            <Link to="/login">Already have an account? Log In</Link>
          </div>
        </form>
      </div>
    );
  }
}

export default SignUpForm;
